import RecipeItem from "../BlogItem";
import { RecipesListContainer } from "./styles";

function RecipesList({ recipes }) {
  return (
    <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-3 grid-cols-1">
      {recipes.map((item) => {
        return <RecipeItem key={item.id} article={item} />;
      })}
    </div>
  );
}

export default RecipesList;
